import React from 'react'
import styles from './style'
import injectSheet from 'react-jss'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

const SelectCameraButton = ({ classes, aov, changeCameraModelAction, selectedCamera, i }) =>
  <div>
    <button
      onClick={_ => changeCameraModelAction(selectedCamera, aov)}
      className={classes.aovButton}
      key={i}
    >
      <FontAwesomeIcon icon='video' /> Select { aov.range_text } Option
    </button>
  </div>

const MultipleAovSelect = props =>
  <div>
    {
      props.aovs.map((aov, i) =>
        <SelectCameraButton
          aov={aov}
          i={i}
          key={i}
          {...props}
        />
      )
    }
  </div>

export default injectSheet(styles)(MultipleAovSelect)



// WEBPACK FOOTER //
// ./src/components/CameraModelSelector/CameraDetailsContainer/CameraDetails/MultipleAovSelect/index.js